export default __webpack_public_path__ + "static/media/03.64e672ad.svg";